import { useState, useEffect } from 'react';
import { Linear } from 'gsap';

export const useParticles = () => {
    const hasWindow = typeof window !== 'undefined' ? true : false;
    const [dimensions, setDimensions] = useState({
        height: 1080,
        width: 1920,
    });

    const [particleSettings] = useState([
        {
            key: 1,
            startPos: dimensions.height + 50,
            endPos: -dimensions.height + 100,
            duration: 11,
            ease: Linear.easeNone,
            divider: 8,
            style: {
                height: 12,
                width: 12,
                background: 'silver',
                left: dimensions.width / 8,
                position: 'absolute',
                borderRadius: 50,
            },
        },
        {
            key: 2,
            startPos: dimensions.height + 50,
            endPos: -dimensions.height + 100,
            duration: 7,
            ease: Linear.easeNone,
            divider: 4,
            style: {
                height: 15,
                width: 15,
                background: 'silver',
                left: dimensions.width / 4,
                position: 'absolute',
                borderRadius: 50,
            },
        },
        {
            key: 3,
            startPos: dimensions.height + 50,
            endPos: -dimensions.height + 100,
            duration: 14,
            ease: Linear.easeNone,
            divider: 1.1,
            style: {
                height: 15,
                width: 15,
                background: 'silver',
                left: dimensions.width,
                position: 'absolute',
                borderRadius: 50,
            },
        },
    ]);

    function particleResize() {
        const arr = particleSettings;
        hasWindow &&
            arr!.forEach((particle) => {
                particle.startPos = window.innerHeight + 50;
                particle.endPos = -window.innerHeight + 100;
                particle.style = { ...particle.style };
                particle.style.left = window.innerWidth / particle.divider;
            });
    }

    function resizeFix() {
        setTimeout(() => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }, 1000);
    }

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
            particleResize();
            resizeFix();
        }
        handleResize();
        hasWindow ? window.addEventListener('resize', handleResize) : console.log('No listener');
        return () => {
            hasWindow && window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasWindow]);

    useEffect(() => {
        console.log(dimensions);
    }, [dimensions]);

    return { particleSettings };
};
